import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'usage-analytics';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GRANULARITY_TYPES = Object.freeze({
  DAILY: 'daily',
  HOURLY: 'hourly',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
} as const);

export const OWNER_TYPES = Object.freeze({
  ORG: 'org',
  TEAM: 'team',
} as const);

export const CONCURRENCY_LIMIT_KEY = 'Concurrency Limit' as const;

export const orgActivityConstants = createApiNamespacedConstants(
  'get_org_analytics',
);

export const teamActivityConstants = createApiNamespacedConstants(
  'get_team_analytics',
);

export const getTeamsConstants = createApiNamespacedConstants(
  'get_teams_analytics',
);

export const setGranularity = `${NAMESPACE}/set_granularity`;
